import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { brandColors as colors } from "@/lib/palette";
import { fonts } from "@/lib/fonts";
import PageShell from "@/components/ui/PageShell";

export function Billing() {
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    api
      .post<{ url: string }>("/api/account/billing-portal")
      .then((r) => {
        window.location.href = r.url;
      })
      .catch((e) => setErr(e instanceof Error ? e.message : "Failed to open billing portal"));
  }, []);

  return (
    <PageShell title="Opening Stripe billing portal…" eyebrow="Billing">
      {err ? (
        <p
          className="text-sm"
          style={{ color: colors.berryRose, fontFamily: fonts.body, fontWeight: 600 }}
        >
          {err}
        </p>
      ) : (
        <p
          style={{
            fontFamily: fonts.body,
            fontWeight: 500,
            color: `${colors.navy}bb`,
            letterSpacing: "0.03em",
          }}
        >
          Hang tight while we hand you off to Stripe.
        </p>
      )}
    </PageShell>
  );
}
